let oauthPopupHandle: Window | null = null;

export const setOAuthPopupHandle = (handle: Window | null): void => {
  oauthPopupHandle = handle;
};

export const getOAuthPopupHandle = (): Window | null => oauthPopupHandle;
